import { COLD_WEATHER_BATTERY_VERSION } from '~/devices/device-helpers';
import { BnAction } from '../../common/bn-action';
import { html, renderIf } from '~/legacy-lit/js/utility/lit-entity';
import '../../common/bn-banner';

class GenerateServiceRequestAction extends BnAction {
  constructor() {
    super();
    this.actionname = 'generate-service-request';
    this.successtext = 'Service Request Created';
    this.errortext = 'An error occurred when trying to create a service request.';
    this.submittext = 'Submit';
  }

  static get properties() {
    return {
      isBatteryUpgradeSelected: { type: Boolean, attribute: false },
      deviceEntity: { type: Object, attribute: false },
    };
  }

  onFormData(event) {
    super.onFormData(event);
    const fieldName = event.detail.name;
    const fieldValue = event.detail.input.value;
    this.isBatteryUpgradeSelected = fieldName === 'preDiagnosis' && fieldValue === 'Battery Upgrade';
  }

  render() {
    return html`
      ${renderIf(this.isBatteryUpgradeSelected && this.deviceEntity?.properties.batteryVersion === COLD_WEATHER_BATTERY_VERSION, () => html`
        <bn-banner severity="warning">
          This device already has a Cold Weather Battery installed.
        </bn-banner>
      `)}
      ${super.render()}
      <lit-entity .href="${this.deviceHref}" @update="${this._onDeviceUpdate}"></lit-entity>
    `;
  }

  async _onDeviceUpdate(e) {
    const { entity } = e.detail;
    this.deviceEntity = entity;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    const action = this.entity.getActionByName(this.actionname);
    this.deviceHref = action.getFieldByName('deviceId').value;
  }
}

window.customElements.define('generate-service-request-action', GenerateServiceRequestAction);
